const Resources = {

    table_headers: [
        { 
          text:     'Name',
          align:    'start',
          value:    'name',
          type:     'text_link_action',
        },
        {
            text:   'Room Types',
            value:  'room_types',
            type: 'text_link_action'
        },
        {
            text:   'Inspection Items',
            value:  'inspection_items',
            type:     'link',
        },
    ],

    deletion_validation_table_headers: [
        { 
          text:     'Inspection Template',
          align:    'start',
          value:    'inspection_template',
        },
        {
            text:   '# of inspections',
            value:  'number_inspections',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Inspection Template',
            href:   '/qc-inspection-template',
            arrow:  "",
        },
    ],

    room_type_table_headers: [
        { 
            name:   'Select',
        },
        {   
            name:   'Room Type',
        },
    ],

    excel_file_headers: {
        'Name': 'Name',
        'Description': 'Description',
        'Instruction': 'Instruction',
        'Active'    : 'status'
    },

    empty_format_data:
    [
        {
            'Name': '',
            'Description': '',
            'Instruction': '',
            'status': 'true'
        },
    ],

    excel_file_headers_room_types: {
        'Inspection Template': 'Inspection Template',
        'Room Type': 'Room Type',
    },

    empty_format_data_room_types:
    [
        {
            'Inspection Template': '',
            'Room Type': '',
        },
    ],

    excel_file_headers_inspection_items: {
        'Inspection Template': 'Inspection Template',
        'Inspection Item': 'Inspection Item',
        'Order': 'Order',
    },

    empty_format_data_inspection_items:
    [
        {
            'Inspection Template': '',
            'Inspection Item': '',
            'Order': '',
        },
    ],

    helps: [
        {
            label: '¿How to create an Inspection Template?', 
            instruction: `https://scribehow.com/embed/How_to_Create_An_Inspection_Template__kQQpB_TcSxyghgVVH-B4gA?as=scrollable`
        },
    ],

}

export default Resources;